"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityArgs = void 0;
const AbilityType_1 = require("./AbilityType");
class AbilityArgs {
    constructor(__type, __typeName, target) {
        this.__type = __type;
        this.__typeName = __typeName;
        this.target = target;
    }
    static FromTypeName(typeName, target) {
        return new AbilityArgs(AbilityType_1.AbilityType[typeName], typeName, target);
    }
    static FromType(abilityType, target) {
        return new AbilityArgs(abilityType, AbilityType_1.AbilityType[abilityType], target);
    }
}
exports.AbilityArgs = AbilityArgs;
